/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-27 16:20:41
 * @LastEditors: K
 * @LastEditTime: 2022-09-05 11:27:28
 */
import { TableColumnType, Tag } from 'antd';
import React from 'react';
import styles from "./diseaseSetPage.module.css";

export const Columns = (
  onClick: (t: any) => void,
  startIndex: number,
): TableColumnType<any>[] => {

  const getIllnessName = (v = 0): string => {
    switch (v) {
      case 1:
        return '特病'
      case 2:
        return '慢病'
      default:
        return '普病'
    }
  }
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },

    {
      title: '疾病编码',
      dataIndex: 'code',
      align: 'center',
    },
    {
      title: '助记码',
      dataIndex: 'zjm',
      align: 'center',
    },
    {
      title: '疾病名称',
      dataIndex: 'name',
      align: 'center',
    },
    {
      title: '疾病类型',
      dataIndex: 'category',
      align: 'center',
      render: (_, t) => getIllnessName(t.category)
    },
    {
      title: '目录类别',
      dataIndex: 'listType',
      align: 'center',
      render: (_, t) => t.listType == 0 ? '医保目录' : '自费目录',
    },
    {
      title: '数据来源',
      dataIndex: 'customFlag',
      align: 'center',
      width: '100px',
      render: (_, t) => t.customFlag == 0 ? '系统录入' : '手工录入',
    },
    {
      title: '操作',
      dataIndex: 'tenantCategory4',
      align: 'center',
      render: function tenantCategory(_, t) {
        return (
          <a onClick={() => onClick(t)}>编辑 </a>
        )
      },
    },


  ]
}

